/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CodeStub } from './CodeStub'
import { Content } from './Content'
import { Duration } from './Duration'
import { Medicinalproduct } from './Medicinalproduct'
import { ParagraphAgreement } from './ParagraphAgreement'
import { RegimenItem } from './RegimenItem'
import { Renewal } from './Renewal'
import { Substanceproduct } from './Substanceproduct'
import { Suspension } from './Suspension'

/**
 * The details of prescribed or suggested medication
 */
export class Medication {
  constructor(json: JSON | any) {
    Object.assign(this as Medication, json)
  }

  compoundPrescription?: string
  substanceProduct?: Substanceproduct
  medicinalProduct?: Medicinalproduct
  numberOfPackages?: number
  batch?: string
  /**
   * The expiration date of the medication. Format: yyyyMMdd
   */
  expirationDate?: number
  instructionForPatient?: string
  instructionForReimbursement?: string
  commentForDelivery?: string
  drugRoute?: string
  temporality?: string
  frequency?: CodeStub
  reimbursementReason?: CodeStub
  substitutionAllowed?: boolean
  beginMoment?: number
  endMoment?: number
  deliveryMoment?: number
  endExecutionMoment?: number
  duration?: Duration
  renewal?: Renewal
  knownUsage?: boolean
  regimen?: Array<RegimenItem>
  posology?: string
  options?: { [key: string]: Content }
  agreements?: { [key: string]: ParagraphAgreement }
  medicationSchemeIdOnSafe?: string
  medicationSchemeSafeVersion?: number
  medicationSchemeTimeStampOnSafe?: number
  medicationSchemeDocumentId?: string
  safeIdName?: string
  idOnSafes?: string
  timestampOnSafe?: number
  changeValidated?: boolean
  newSafeMedication?: boolean
  medicationUse?: string
  beginCondition?: string
  endCondition?: string
  origin?: string
  medicationChanged?: boolean
  posologyChanged?: boolean
  suspension?: Array<Suspension>
  prescriptionRID?: string
  status?: number
}
